import React from 'react';
import { Bell, AlertCircle, Calendar, ChevronRight } from 'lucide-react';
const alerts = [{
  id: 1,
  type: 'Urgent',
  title: 'Boil Water Advisory: West District',
  date: 'October 24, 2023',
  description: 'A precautionary boil water advisory has been issued for residents in the West District following a main break. Water should be boiled for at least one minute before consumption.',
  urgent: true
}, {
  id: 2,
  type: 'Notice',
  title: 'Seasonal Flu Vaccine Clinics Now Open',
  date: 'October 18, 2023',
  description: 'Free flu vaccination clinics are now available at community centers across the county. Walk-ins are welcome, but appointments are recommended.',
  urgent: false
}, {
  id: 3,
  type: 'Recall',
  title: 'Food Safety Recall: Brand X Packaged Salads',
  date: 'October 15, 2023',
  description: 'The FDA has issued a recall for specific batches of packaged salads due to potential listeria contamination. Check your refrigerators and dispose of affected products.',
  urgent: true
}];
export function NewsAlerts() {
  return <section className="py-20 bg-white border-t border-gov-border" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <div className="flex flex-col lg:flex-row gap-12" data-id="element-122">
          {/* Section Header */}
          <div className="lg:w-1/3" data-id="element-123">
            <div className="flex items-center space-x-3 mb-4" data-id="element-124">
              <div className="p-2 bg-red-100 text-red-700 rounded-lg" data-id="element-125">
                <Bell className="w-6 h-6" data-id="element-126" />
              </div>
              <h2 className="text-3xl font-black text-gov-navy" data-id="element-127">
                News & Alerts
              </h2>
            </div>
            <p className="text-gov-slate mb-8 text-lg" data-id="element-128">
              Stay informed with the latest public health notices, recalls, and
              community health updates from Franklin County.
            </p>
            <a href="#all-news" className="inline-flex items-center text-gov-navy font-bold hover:text-gov-amber transition-colors" data-id="element-129">
              View News Archive <ChevronRight className="w-5 h-5 ml-1" data-id="element-130" />
            </a>
          </div>

          {/* Alerts List */}
          <div className="lg:w-2/3 space-y-4" data-id="element-131">
            {alerts.map(alert => <div key={alert.id} className={`p-6 rounded-xl border ${alert.urgent ? 'border-red-200 bg-red-50' : 'border-gov-border bg-white'} shadow-sm hover:shadow-md transition-shadow`} data-id="element-132">
                <div className="flex flex-col sm:flex-row sm:items-start justify-between mb-3" data-id="element-133">
                  <div className="flex items-center space-x-3 mb-2 sm:mb-0" data-id="element-134">
                    {alert.urgent ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-red-100 text-red-800 border border-red-200" data-id="element-135">
                        <AlertCircle className="w-3.5 h-3.5 mr-1" data-id="element-136" />
                        {alert.type}
                      </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-blue-100 text-blue-800 border border-blue-200" data-id="element-137">
                        {alert.type}
                      </span>}
                    <span className="flex items-center text-sm text-gov-slate font-medium" data-id="element-138">
                      <Calendar className="w-4 h-4 mr-1.5 text-gray-400" data-id="element-139" />
                      {alert.date}
                    </span>
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gov-navy mb-2" data-id="element-140">
                  <a href={`#news-${alert.id}`} className="hover:underline decoration-2 underline-offset-2" data-id="element-141">
                    {alert.title}
                  </a>
                </h3>
                <p className="text-gov-slate leading-relaxed" data-id="element-142">
                  {alert.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}